<div class="references-section w-full bg-neutral-50 p-4 rounded-lg">
  @if (isCollapsable()) {
    <flx-accordion>
      <flx-accordion-item [opened]="!isCollapsed()">
        <ng-container flxAccordionItemTitle>
          <span> {{ header() }}</span>
        </ng-container>

        <ng-template [ngTemplateOutlet]="attributesTemplate"></ng-template>
      </flx-accordion-item>
    </flx-accordion>
  } @else {
    <div class="px-4 py-2">
      <div class="text-sm font-semibold">{{ header() }}</div>
      <ng-template [ngTemplateOutlet]="attributesTemplate"></ng-template>
    </div>
  }
</div>

<ng-template #attributesTemplate>
  @if (references()?.length > 0) {
    <span class="text-left text-neutral-400 text-xs font-normal pt-2"> Attributes </span>
  }
  @for (attribute of references(); track attribute) {
    <flx-attribute-references
      [isCollapsed]="!$first"
      [isCollapsable]="$count > 1"
      [references]="attribute.references"
      [path]="attribute.path"
      [resourceType]="resourceType()"
      class="my-2"
    ></flx-attribute-references>
  }
</ng-template>
